import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'react-final-form';
import cn from 'classnames';
import { useConfig } from '@websky/core/src/context';
import { submitForm, redirectToFastSearch } from '@websky/core/src/SearchForm/store/actions';
import { canAddSegment as getCanAddSegment, getSegments, isMultiCity as getIsMultiCity } from '@websky/core/src/SearchForm/store/segments/selectors';
import { generateOfferHotelLink, setFieldDataMutator } from '@websky/core/src/SearchForm/utils';
import Segments from './Segments/Segments';
import Controls from './Controls/Controls';
import Actions from './Actions/Actions';
import Bottom from './Bottom/Bottom';
import { useFormsContext } from '../../Forms/context';
const LastSearch = React.lazy(() => import('@websky/core/src/SearchForm/components/SearchForm/LastSearch/LastSearch'));
import css from './SearchFormWidget.css';
import { getPassengersForRequest, getTotalPassengersCount } from '@websky/core/src/SearchForm/store/passengers/selectors';
import { isOfferHotels as getIsOfferHotels } from '@websky/core/src/SearchForm/store/offerHotels/selectors';
const SearchFormWidget = React.memo(({ onSubmit, renderPromoCode }) => {
    const dispatch = useDispatch();
    const { global: { companyInfo: { iataCode } }, SearchForm: { engineURL, proMode, offerHotelsLink, offerHotelsSupplier, offerHotelsAdditionalId, offerHotelsUtm } } = useConfig();
    const isMultiCity = useSelector(getIsMultiCity);
    const canAddSegment = useSelector(getCanAddSegment);
    const segments = useSelector(getSegments);
    const passengersCount = useSelector(getTotalPassengersCount);
    const passengers = useSelector(getPassengersForRequest);
    const isOfferHotels = useSelector(getIsOfferHotels);
    const { onChangeMultiCity } = useFormsContext();
    React.useEffect(() => {
        onChangeMultiCity(isMultiCity);
    }, [isMultiCity]);
    const generatedHotelLink = isOfferHotels
        ? generateOfferHotelLink(offerHotelsLink, segments, passengersCount, passengers, iataCode, offerHotelsSupplier, offerHotelsAdditionalId, offerHotelsUtm)
        : null;
    const handleSubmit = React.useCallback(() => {
        if (onSubmit) {
            dispatch(submitForm(onSubmit));
        }
        else if (engineURL) {
            dispatch(redirectToFastSearch({
                openOfferHotelsStrategy: 'currentTab',
                hotelsUrl: generatedHotelLink,
                engineUrl: engineURL
            }));
        }
    }, [dispatch, generatedHotelLink]);
    return (React.createElement("div", { className: css.container },
        React.createElement(Form, { onSubmit: handleSubmit, mutators: { setFieldData: setFieldDataMutator }, subscription: {} }, ({ handleSubmit }) => (React.createElement("form", { className: css.form, onSubmit: handleSubmit, "data-search-form": true },
            React.createElement(Bottom, { renderPromoCode: renderPromoCode }),
            React.createElement("div", { className: cn(css.row, { [css.row_multiCity]: isMultiCity }) },
                React.createElement(Segments, null),
                !proMode && canAddSegment && React.createElement(Actions, null),
                React.createElement(Controls, null))))),
        proMode && (React.createElement(React.Suspense, { fallback: "Loading..." },
            React.createElement(LastSearch, null)))));
});
export default SearchFormWidget;
